import { Box, Loader, Stack, UnstyledButton, Flex } from "@mantine/core";
import { IFolderAgGrid } from "@mctypes/global.types";
import React from "react";
import { VSpace } from "..";
import "./FolderSelector.css";

const FolderSelector: React.FC<{
  currentFolder: IFolderAgGrid;
  folders: IFolderAgGrid[];
  onSelectActiveFolder: (folder: IFolderAgGrid) => void;
  onGoToNextFolder: (folder: IFolderAgGrid) => void;
  highlightedFolder?: IFolderAgGrid;
  goBack: () => void;
  canGoBack: boolean;
  isLoading?: boolean;
}> = ({
  currentFolder,
  folders,
  onSelectActiveFolder,
  highlightedFolder,
  goBack,
  onGoToNextFolder,
  canGoBack,
  isLoading,
}) => {
  return (
    <Flex direction="column" h="100%" miw="400px" style={{ overflow: "auto" }}>
      {currentFolder != null ? (
        <Flex h="40px" align="center">
          <span>{currentFolder?.name}</span>
          {isLoading === true && <Loader ml="0.5rem" size="xs" />}
        </Flex>
      ) : (
        <Flex h="40px" align="center">
          <span>Root</span>
          {isLoading === true && <Loader ml="0.5rem" size="xs" />}
        </Flex>
      )}
      <VSpace />
      <Stack gap={0} className="folderSelectorList" h="100%" style={{ overflow: "auto" }}>
        {canGoBack === true && (
          <UnstyledButton
            type="button"
            className="folderSelectorRow folderSelectorRowButton"
            onDoubleClick={() => goBack()}
          >
            <i className="fa fa-folder fa-fw" />
            <span>...</span>
          </UnstyledButton>
        )}
        {canGoBack === false && (
          <Box className="folderSelectorRow folderSelectorRowDisabled">
            <i className="fa fa-folder fa-fw" />
            <span>...</span>
          </Box>
        )}
        {isLoading === true && folders.length === 0 && (
          <Box className="folderSelectorRow folderSelectorRowMuted">
            <Loader size="xs" />
            <span>Henter mapper...</span>
          </Box>
        )}
        {folders.map((folder) => (
          <UnstyledButton
            type="button"
            onDoubleClick={() => onGoToNextFolder(folder)}
            onClick={() => onSelectActiveFolder(folder)}
            className={`folderSelectorRow folderSelectorRowButton ${
              highlightedFolder?.id === folder.id ? "folderSelectorRowActive" : ""
            }`}
            key={folder.id}
          >
            <i className="fa fa-folder fa-fw" />
            <span className="truncateHeaderText">{folder.name}</span>
          </UnstyledButton>
        ))}
      </Stack>
    </Flex>
  );
};

export default FolderSelector;
